import { getPayAsYouGoMeterValues } from "@stores/subscriptions/utils";
import { ManageCard } from "./ManageCard";
import { formatPrice } from "@common/utils/string";
import { contractedFreeUnits, meteredLineItem } from "../utils";
import { IAddOnContext, IMeteredAddOnDescriptor } from "../types";
import { ADDON_METABASE_AI_MANAGED_PRICE_PER_TOKEN } from "@stores/addons/constants";

/**
 * Managed Metabase AI. Enabled and disabled in the instance itself, not through
 * a plan change, so it has no payload builders.
 */
const getPricePerUnit = ({ subscribed, addOn }: IAddOnContext): number =>
  (subscribed?.price_per_unit ?? addOn?.default_price_per_unit) ||
  ADDON_METABASE_AI_MANAGED_PRICE_PER_TOKEN;

const metabaseAiManaged = {
  productType: "metabase-ai-managed",
  kind: "metered",
  title: "Metabase AI Service",

  isVisible: ({ subscribed, isCloudHosted }) => isCloudHosted && !!subscribed,

  getUsage: (ctx: IAddOnContext) => {
    if (!ctx.subscribed) {
      return undefined;
    }

    const freeUnits = contractedFreeUnits(ctx);

    return {
      hasQuota: true,
      usage: ctx.subscribed.meter_value ?? 0,
      includedUnits: freeUnits,
      ...getPayAsYouGoMeterValues({
        meterValue: ctx.subscribed.meter_value,
        freeUnits,
        meterFreeUnits: ctx.subscribed.meter_free_units,
      }),
    };
  },

  getIncludedUnits: contractedFreeUnits,

  getPricePerUnit,

  getEstimateRowItem: (ctx) => ({
    detail: "Usage-based billing",
    price:
      ctx.addOn &&
      `${formatPrice(1_000_000 * getPricePerUnit(ctx))} per 1M tokens`,
  }),

  getBillingRowItem: () => ({ detail: "Usage-based billing" }),
  getPurchaseLineItem: (ctx) => meteredLineItem(ctx, "tokens", 1),

  ManageCard,
} satisfies IMeteredAddOnDescriptor;

export default metabaseAiManaged;
